var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 398.9 292.66",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 202.08,
    y1: 197.26,
    x2: 259.68,
    y2: 197.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 209.84,
    y1: 107.83,
    x2: 134.16,
    y2: 169.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 270.5,
    y1: 184.82,
    x2: 286.56,
    y2: 184.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 277.31,
    y1: 271.06,
    x2: 303.02,
    y2: 251.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 229.39,
    y1: 202.48,
    x2: 239.64,
    y2: 202.48,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 111.86,
    y1: 4.71,
    x2: 102.43,
    y2: 233.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 152.63,
    y1: 137.02,
    x2: 160.88,
    y2: 137.02,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 170.5,
    y1: 151.35,
    x2: 176.81,
    y2: 151.35,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Profile Analyze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M291.53,139.74C299.81,153,304.45,169.3,317,178.52c17.62,12.9,44.36,7,61.46,20.57,7.9,6.27,12.43,15.78,16.07,25.18,5.31,13.74,9.15,29.63,2.52,42.78-7.66,15.19-26.22,21-43,23.52-23.24,3.55-47,3.88-69.79,9.73-9.09,2.34-18,5.54-27.19,7.25s-18.43,1.88-27.69,1.72A364.81,364.81,0,0,1,98.91,282.65c-33.13-13.43-65.65-33.14-83.45-64.15A104.69,104.69,0,0,1,2.87,151.17C4.81,138.47,9.2,126,16.68,115.58,27.17,101,43.23,91,60.27,85.26s35.15-7.62,53.12-8.57c37.09-2,83.89-5.33,118.24,11,10.24,4.88,17.76,11.53,26,19.07C269.45,117.52,282.91,126,291.53,139.74Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.69,
    width: 187.86,
    height: 286,
    rx: 11.02,
    fill: "#19b24b",
    opacity: 0.43,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,222.23l1.25,19.15a20.77,20.77,0,0,1-6.77-4.2C235,227.94,227.66,215.37,220.68,203q-8.9-15.83-17.43-31.83c-2.08-3.89-4.24-7.92-7.71-10.65,3.27-1.85,7.36-2.9,10.76-1.3,4.15,1.95,5.71,6.89,7.87,10.93,2.25,4.21,5.48,7.8,8.35,11.61a79.13,79.13,0,0,1,9.31,15.93,12.07,12.07,0,0,0,1.76,3.16,11.71,11.71,0,0,0,4,2.56,125,125,0,0,1,13.18,7.13,16,16,0,0,1,4,3.18,8.61,8.61,0,0,1,1.86,6.2C256.29,223.85,254.42,222,251.37,222.23Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b",
    opacity: 0.34,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.35,214.62c-1.85.41-3.83.91-5,2.36s-1,4.17.8,4.74a5.58,5.58,0,0,0,1.58.14c7.7.17,12.52,9.06,20,10.77a19,19,0,0,0,8.14-.32,15.5,15.5,0,0,0,6.59-2.68c1.36-1.1,2.68-2.7,4.42-2.53,2,.19,2.92,2.51,3.37,4.46,4.07,17.72,3,36.16,1.83,54.31-.38,6-.51,12.26-.62,18.29,0,2.13,0,4.45,1.29,6.14,1.83,2.35,5.28,2.46,8.26,2.35,1.92-.08,4.06-.25,5.38-1.66s1.34-3.35,1.35-5.18q.18-28.71-2.28-57.34c-.44-5.05.82-17.32.76-22.39-.05-5.34,1.74-13.59,2.67-18.85,2.34-13.34,4.67-15.87,6.67-29.26a17.77,17.77,0,0,0,6.09,2.85c2.22.41,4.78-.2,6.06-2.06a8.58,8.58,0,0,0,1.09-4.54,106.54,106.54,0,0,0-.16-12.25,5.92,5.92,0,0,0-.67-2.76,6.06,6.06,0,0,0-2.6-2l-13.46-6.7a9.88,9.88,0,0,0-4.67-1.43,7.78,7.78,0,0,0-4.79,2.39c-7.35,6.87-7.39,18.22-8.39,28.23-.84,8.42-2.81,16.94-7.45,24s-12.31,12.54-20.77,12.9A43.06,43.06,0,0,1,101.35,214.62Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b",
    opacity: 0.34,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.18,54.6v50.06a5.63,5.63,0,0,1-5.63,5.63H89.8a5.63,5.63,0,0,1-5.63-5.63V54.6A5.64,5.64,0,0,1,89.8,49h36.75A5.64,5.64,0,0,1,132.18,54.6Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.74,225.46a5.63,5.63,0,0,1-2.53,2.07,5.42,5.42,0,0,1-3.1-.25,45.38,45.38,0,0,1-20-12.39,18.06,18.06,0,0,1,2.74-4.32A33.61,33.61,0,0,0,118,213a2.62,2.62,0,0,0,1.52-.26,2.58,2.58,0,0,0,.75-.92q2.7-4.59,5-9.4c2-4.25,4-8.89,8-11.38a2.2,2.2,0,0,1,1.22-.43,2.42,2.42,0,0,1,1.24.54c3,2,6.36,4.3,7.74,7.82,1.19,3-.1,4.92-1.65,7.49C137.85,212.93,134.54,219.51,129.74,225.46Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.6,255.29c-2.76-.78-4.67-3.43-5.41-6.21s-1.88-11-1.7-13.85a231.35,231.35,0,0,0-1.06-41c-.09-.76,16.81-5.2,18.4-4.19,3.79,2.4.68,14.06.08,17.82C152.6,222.28,149.27,241.48,144.6,255.29Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 147.65,
    y: 35.05,
    width: 84.12,
    height: 5.61,
    fill: "#19b24b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147.65,
    y: 49.42,
    width: 61.3,
    height: 5.61,
    fill: "#19b24b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.65,
    y: 62.39,
    width: 84.12,
    height: 5.61,
    fill: "#19b24b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.65,
    y: 76.76,
    width: 74.43,
    height: 5.61,
    fill: "#19b24b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82.99,
    y: 94.46,
    width: 148.61,
    height: 5.61,
    fill: "#19b24b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82.99,
    y: 108.83,
    width: 116.57,
    height: 5.61,
    fill: "#19b24b"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82.99,
    y: 121.79,
    width: 148.61,
    height: 5.61,
    fill: "#19b24b"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82.99,
    y: 136.16,
    width: 130.95,
    height: 5.61,
    fill: "#19b24b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.64,235.76l-7,3.51L202,158.53c3-1.44,4.54-2,7-4.14Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.68,236.19l-7,3.51L202.08,159c3-1.43,4.54-2,7-4.14Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187,90.14a36.27,36.27,0,1,0,36.27,36.28A36.28,36.28,0,0,0,187,90.14Zm-.73,65.92a29.62,29.62,0,1,1,29.61-29.62A29.62,29.62,0,0,1,186.31,156.06Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187,90.14a36.27,36.27,0,1,0,36.27,36.28A36.28,36.28,0,0,0,187,90.14Zm-.73,65.92a29.62,29.62,0,1,1,29.61-29.62A29.62,29.62,0,0,1,186.31,156.06Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient-2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,126.44a29.62,29.62,0,1,1-29.61-29.61A29.62,29.62,0,0,1,215.92,126.44Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b",
    strokeMiterlimit: 10,
    strokeWidth: 0.62,
    opacity: 0.53
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.82,179.48c-.44.11-1,.18-1.19.57a1.47,1.47,0,0,0-.11.86l.48,5.55a5.9,5.9,0,0,0,.63,2.56c.87,1.44,2.75,1.83,4.42,2s3.54.45,4.6,1.76c.57.7.86,1.67,1.64,2.12a3.38,3.38,0,0,0,2.29.1,2.61,2.61,0,0,0,1.42-.58,2.08,2.08,0,0,0,.11-2.31A14.53,14.53,0,0,1,285,190c-.41-1.54.5-3.07,1-4.57a8.71,8.71,0,0,0-1.83-9,7,7,0,0,0-7.32-1.41C274.57,175.89,274.42,178.86,271.82,179.48Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient-3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M275.83,170.08a.74.74,0,0,0-1.17.08,1.2,1.2,0,0,0-.11.65,5.72,5.72,0,0,0,1.95,3.83,20.7,20.7,0,0,0,3.63,2.5,5.61,5.61,0,0,1,2.07,1.79,5.42,5.42,0,0,1,.2,3.95c-.07.31-.11.72.18.87s.71-.24,1.11-.32a.87.87,0,0,1,.91.8,2.05,2.05,0,0,1-.4,1.28,2.5,2.5,0,0,1-.92,1c-.14.06-.3.13-.33.28s.09.25.19.34c.47.43.95.85,1.44,1.25a1.94,1.94,0,0,0,1,.52,2,2,0,0,0,1.42-.81l3.13-3.28a2.56,2.56,0,0,0,.7-1,2.34,2.34,0,0,0,0-1.05,3.3,3.3,0,0,0-1.66-2.58,4.07,4.07,0,0,0,1-3,6.36,6.36,0,0,0-2.27-4.69,21.44,21.44,0,0,0-4.37-2.31,15,15,0,0,1-4.63-3.6,2.06,2.06,0,0,0-.86-.72c-.75-.25-1.57.52-1.91,1.14A5.44,5.44,0,0,0,275.83,170.08Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M267,206a6.83,6.83,0,0,1-2.27,1.14,7.61,7.61,0,0,1-2.69-.07c-6.57-1-13.1-2.32-19.55-3.94a1.73,1.73,0,0,0-1.53.1,1.78,1.78,0,0,0-.44.89l-1.33,5a1.41,1.41,0,0,0,1,2.05q8.51,3.85,17.1,7.49a15.51,15.51,0,0,0,5.88,1.61,13.76,13.76,0,0,0,4.62-1A57.28,57.28,0,0,0,282,211.79l12.79,12.76c2.18,2.18,4.66,4.49,7.74,4.66a12.4,12.4,0,0,0,5.21-1.23q5.5-2.17,10.94-4.49a2.62,2.62,0,0,0,1.52-1.15,2.17,2.17,0,0,0,0-1.38,11,11,0,0,0-2.73-4.5,141.91,141.91,0,0,0-23.48-21.61c-1.71-1.25-3.8-2.8-5.93-3.23-1.81-.37-3.94.94-5.49,1.82-3.69,2.11-6.79,5.09-9.95,7.89A60.9,60.9,0,0,1,267,206Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#19b24b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.7,293.22a2.62,2.62,0,0,0-.14,2.48,2.47,2.47,0,0,0,1.66.79,23.21,23.21,0,0,0,6.81.17c2.07-6.49,5.84-12.29,9.56-18q8.4-12.92,16.81-25.81c6.47-9.94,13-20,16.89-31.21-.23.67-9.64,2.56-10.9,3-2.79,1-6.64,2.13-9.08,3.88-5.24,3.78-8.47,13.26-11.33,18.92C281.46,262.37,275.08,277.8,268.7,293.22Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.7,293.22a2.62,2.62,0,0,0-.14,2.48,2.47,2.47,0,0,0,1.66.79,23.21,23.21,0,0,0,6.81.17c2.07-6.49,5.84-12.29,9.56-18q8.4-12.92,16.81-25.81c6.47-9.94,13-20,16.89-31.21-.23.67-9.64,2.56-10.9,3-2.79,1-6.64,2.13-9.08,3.88-5.24,3.78-8.47,13.26-11.33,18.92C281.46,262.37,275.08,277.8,268.7,293.22Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient-4)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303.56,258.47a8.15,8.15,0,0,0,3.74,6.92c9.27,7.78,19.1,14.87,28.92,22a13.54,13.54,0,0,0,6.56-5.24,173.39,173.39,0,0,1-21.43-17.89c-1.59-1.51-3.26-3.19-3.59-5.35-.27-1.76.41-3.51,1-5.2,2.11-6.29,2.88-12.93,3.64-19.52.42-3.65.8-7.53-.83-10.82a3.93,3.93,0,0,0-1.31-1.64c-1.1-.7-2.53-.45-3.79-.13a58.12,58.12,0,0,0-11.39,3.93c-3,1.49-3.07,2.78-3,6C302.21,240.49,302.58,249.48,303.56,258.47Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.81,295.55c-2.51.74-4.51,2.58-6.42,4.36-.6.56-1.25,1.43-.79,2.11a1.7,1.7,0,0,0,1.21.57,27.49,27.49,0,0,0,6.47.28,8.49,8.49,0,0,0,3.72-1,3.61,3.61,0,0,0,1.88-3.17,3.43,3.43,0,0,0-2.63-2.88,6.2,6.2,0,0,0-4.05.54",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M334.05,288.51c-1,.94-2.09,2.33-1.49,3.59a2.52,2.52,0,0,0,2.33,1.19A8.84,8.84,0,0,0,339,291.8c3-1.69,6.18-3.25,9-5.21C344.63,278.63,338.29,284.6,334.05,288.51Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232.75,198.3a3.48,3.48,0,0,0-.94-.57,1.71,1.71,0,0,0-1.46.17,2.56,2.56,0,0,0-.92,2.61c.14,1,.58,1.88.77,2.84a6,6,0,0,0,.79,2.75,4,4,0,0,0,2.84,1c2.25.2,6.74.91,5.63-3C238.8,201.78,234.57,199.7,232.75,198.3Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient-5)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124.08,110.29H91.52s0,0,0,0c-1.94-2.52,1.09-12.08,2.14-14.58.45-1.07,7.33-11,7.7-10.32-2.12-3.65-4.32-7.55-4.19-11.78.15-5.29,4.22-10,9.24-11.69,5.51-1.82,12.64.52,14.41,6a12.78,12.78,0,0,1,.22,5.9,23.69,23.69,0,0,1-6.49,12.71c5.2,1.63,7.57,7.54,8.9,12.82C124.18,102.36,124.82,107.27,124.08,110.29Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient-6)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.8,140.2c0,1.14-.09,2.42-1,3.16a2.62,2.62,0,0,1-2.74.22,5.69,5.69,0,0,1-2.12-1.93,13.08,13.08,0,0,1-1.62-2.87,9.85,9.85,0,0,1-.71-4.29,5.51,5.51,0,0,1,.54-2.16,4.28,4.28,0,0,1,3.89-2.16c1.59.06,3.83,1.1,3.8,2.87C160.84,135.42,160.83,137.81,160.8,140.2Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient-7)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.89,147.12c-.21.69-.32,1.61.31,1.95a1.7,1.7,0,0,0,.87.13,5.87,5.87,0,0,1,4.5,1.69A6.55,6.55,0,0,1,165,154.6c.13,1.33.08,2.68.27,4,.3,2,5,5.31,5.34,4.4a14.59,14.59,0,0,0,.7-6.87c-.11-.8-.19-1.79.48-2.21a1.84,1.84,0,0,1,1.27-.12,12.15,12.15,0,0,1,3.75,1.23c-.48,1.18,1.74,11.68,1.56,14.26-.7,10.16-13.23,2-15.36.83-.59-.31-1.24-.93-1-1.54-.51,3.81-1.21,7.87-1.72,11.68-.44,3.26-.94,6.68-2.88,9.34a14.24,14.24,0,0,1-6.09,4.44c-5.32,2.25-11.82,2.44-16.55-.86a6.07,6.07,0,0,1-2.26-2.51,7.48,7.48,0,0,1-.36-3.16,105.28,105.28,0,0,1,2.64-20.22c1.19-5.18,3-10.57,7.05-14C145.7,150.07,152.87,147.69,157.89,147.12Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.69,117.77a11.79,11.79,0,0,0-8.71,3.76,23.49,23.49,0,0,0-4.94,8.36c-1,2.7-1.82,5.55-3.54,7.87-2.32,3.14-6,4.9-9.3,7s-6.54,5-7,8.92c-.25,2.16.43,4.35.17,6.5-.32,2.62-2,5.28-.94,7.71a5.39,5.39,0,0,0,1.85,2.17,9.62,9.62,0,0,0,11.13,0c3.44-2.56,4.76-7.17,7.94-10.05,3.49-3.16,8.6-3.75,12.54-6.31a14.78,14.78,0,0,0,6.62-12.75c-.07-1.85-.5-3.74,0-5.52s1.77-3.08,2.2-4.79c.54-2.1-.36-6-1.08-8.06C158.69,119.72,155.59,117.92,152.69,117.77Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.22,151.46a4,4,0,0,1-.7-1.38,1,1,0,0,1,.68-1.22,2.81,2.81,0,0,0,.71-.07,1,1,0,0,0,.33-.26,1.77,1.77,0,0,1,1.5-.4,1.75,1.75,0,0,1,1.21,1,.87.87,0,0,1,.81.34,1.89,1.89,0,0,1,.34.84,1.15,1.15,0,0,0,.18.52c.09.12.23.18.33.29a1.25,1.25,0,0,1,.16,1l-.27,2.07a.6.6,0,0,1-.06.23c-.14.24-.5.19-.77.11a10.12,10.12,0,0,0-2.19-.36C171.73,154.09,172,152.75,171.22,151.46Z",
    transform: "translate(-1.71 -26.18)",
    fill: "url(#linear-gradient-8)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.84,258a2.93,2.93,0,0,0,.18,1.25c.49,1.1,2,1.37,3.34,1.44a55,55,0,0,0,7.81-.16,2.71,2.71,0,0,0,1.66-.55,1.45,1.45,0,0,0-.14-2,5.07,5.07,0,0,0-2.05-1.13,5.52,5.52,0,0,1-2.08-1.09,3.46,3.46,0,0,1-.88-2.49c0-.9.12-1.79,0-2.68a.53.53,0,0,0-.19-.41.65.65,0,0,0-.37-.08c-1.67-.05-5.79-.74-7,.65S138.86,256.3,138.84,258Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.72,206.34a3,3,0,0,0-1.31-.48,2.87,2.87,0,0,0-1.73.77,24.59,24.59,0,0,0-5.51,6c-.82,1.24-1.57,2.87-1,4.29,2.17.49,4.48,1,6.53,0a18.34,18.34,0,0,1,2.11-1.09,3.23,3.23,0,0,1,2.61.29c.75.43,1.46,1.19,2.29,1.08a2.33,2.33,0,0,0,1.32-.9c1.18-1.42,2.6-4.39,1.46-6.16S103.35,207.25,101.72,206.34Z",
    transform: "translate(-1.71 -26.18)",
    fill: "#3e3e54"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "122.94 234.91 150.11 234.47 150.11 292.65 68.09 292.65 68.09 270.57 86.67 270.57 86.67 256.2 112.25 256.2 112.25 234.82 122.94 234.91",
    fill: "#19b24b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d0df0ea6674a39f54a9b2689e129e926.svg";
export { ForwardRef as ReactComponent };